
<template>
  <div>
    <div
      style="position: absolute; top: 0; left: 0; margin: 10% 0%"
      class="menutopOnly"
    >
      <dl class="nav clearfix" id="nav" style="padding: 0 10%">
        <dd class="" style="height: 250px; width: 28%; float: left">
          <p style="text-align: left" class="titletopsty">
            <a @click="first_method()" class="font20">走进西樵山</a>
          </p>
          <ul class="subnav font16" style="text-align: left">
            <li
              v-for="item in dataList1"
              :key="item.id"
              style="float: left; width: 33%; text-align: left"
              class="hover4"
            >
              <a @click="first_method_public1(item.sort)" class="justcolor">{{ item.title }}</a>
            </li>
          </ul>
        </dd>

        <dd style="width: 7%; float: left; padding-top: 10px">
          <div
            style="float: left; width: 1px; height: 75px; background: #000"
          ></div>
        </dd>

        <dd style="height: 250px; width: 28%; float: left; text-align: left">
          <p class="t ">
            <a @click="first_method_PlayAllOverForInfomation()" class="font20">讯游西樵山</a>
          </p>
          <ul class="subnav font16">
            <li
              v-for="item in dataList2"
              :key="item.id"
              style="float: left; width: 30%"
              class="hover4"
            >
              <a @click="first_method_public2(item.sort)" class="justcolor">{{ item.title }}</a>
            </li>
          </ul>
        </dd>

        <dd style="width: 7%; float: left; padding-top: 10px">
          <div
            style="float: left; width: 1px; height: 75px; background: #000"
          ></div>
        </dd>

        <dd
          class=""
          style="height: 250px; width: 28%; float: left; text-align: left"
        >
          <p class="t">
            <a @click="first_method_PlayAllOver()" class="font20">玩遍西樵山</a>
          </p>
          <ul class="subnav font16">
            <li
              v-for="item in dataList3"
              :key="item.id"
              style="float: left; width: 30%"
              class="hover4"
            >
              <a @click="first_method_public3(item.sort)" class="justcolor">{{ item.title }}</a>
            </li>

          </ul>
        </dd>
        <dd
          class=""
          style="height: 250px; width: 28%; float: left; text-align: left"
        >
          <p class="t">
            <a @click="first_method_BeautyAllOver()" class="font20">醉美西樵山</a>
          </p>
          <ul class="subnav font16">
            <li
              v-for="item in dataList4"
              :key="item.id"
              class="folatL30 hover4"
            >
              <a @click="first_method_public4(item.sort)" class="justcolor">{{ item.title }}</a>
            </li>
            <!-- <li class="folatL30 hover4" >
              <a @click="first_method_BeautyAllOver()">西樵山揽胜</a>
            </li>
            <li class="folatL30 hover4">
              <a @click="first_method_BeautyAllOverForMove()">西樵山影音</a>
            </li>
            <li class="folatL30 hover4">
              <a @click="first_method_BeautyAllOverForRadio()">语音导赏</a>
            </li>
            <li class="folatL30 hover4">
              <a href="http://www.baidu.com">720全景游</a>
            </li>
            <li class="folatL30 hover4">
              <a href="http://www.baidu.com">电子书籍</a>
            </li> -->
          </ul>
        </dd>
        <dd style="width: 7%; float: left">
          <div
            style="float: left; width: 1px; height: 55px; background: #000"
          ></div>
        </dd>
        <dd
          class=""
          style="height: 250px; float: left; width: 28%; text-align: left"
        >
          <p class="t">
            <a  class="font20">智游西樵山</a>
          </p>
          <ul class="subnav font16">
            <li
              class="folatL30 hover4"
              v-for="item in dataList5"
              :key="item.id"
            >
              <a :href="item.route" class="justcolor">{{ item.title }}</a>
            </li>
            <!-- <li class="folatL30 hover4">
              <a href="http://www.baidu.com">票务预订</a>
            </li>
            <li class="folatL30 hover4">
              <a href="http://www.baidu.com">团队业务预订</a>
            </li>
            <li class="folatL30 hover4">
              <a href="http://www.baidu.com">酒店/名宿预订</a>
            </li>
            <li class="folatL30 hover4">
              <a href="http://www.baidu.com">导游预订</a>
            </li>
            <li class="folatL30 hover4">
              <a href="http://www.baidu.com">餐饮预订</a>
            </li>
            <li class="folatL30 hover4">
              <a href="http://www.baidu.com">文创产品商城</a>
            </li>
            <li class="folatL30 hover4">
              <a href="http://www.baidu.com">停/寻车服务</a>
            </li>
            <li class="folatL30 hover4">
              <a href="http://www.baidu.com">在线咨询</a>
            </li> -->
          </ul>
        </dd>
        <dd style="width: 7%; float: left">
          <div
            style="float: left; width: 1px; height: 55px; background: #000"
          ></div>
        </dd>
        <dd
          class=""
          style="height: 250px; width: 28%; float: left; text-align: left"
        >
          <p class="t">
            <a href="#" class="font20">language</a>
          </p>
          <ul class="subnav font16">
            <li class="folatL30 hover4">
              <a @click="first_method()" class="justcolor">中文版</a>
            </li>
             <li class="folatL30 hover4">
              <a @click="first_method_to_jpn()" class="justcolor">日本語</a>
            </li>
            <li class="folatL30 hover4">
              <a @click="first_method_to_en()" class="justcolor">English</a>
            </li>
          </ul>
        </dd>
      </dl>

      <!-- 导航按钮弹出的界面 -->
      <div class="menubot" style="padding-top: 5%">
        <div class="menulink">
          <a style="color: #7f7f7f">佛山市南海区西樵镇环山大道西樵山南门入口</a>
          <a style="color: #7f7f7f">佛山市南海区西樵山森林公园旅游开发总公司</a>
          <a style="color: #7f7f7f">咨询电话400-111-9288</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getZJXQSList,
  getXUYOUlist,
  getPlayList,
  getBeautyList,
  getZHIYOUList
} from '@/api/public'
export default {
  components: {},
  data () {
    return {
      stylea: '',
      toUrl: '',
      dataList1: [],
      dataList2: [],
      dataList3: [],
      dataList4: [],
      dataList5: []
    }
  },
  beforeCreate () {},
  created () {
    this.toUrl = window.location.origin
    this.init1()
    this.init2()
    this.init3()
    this.init4()
    this.init5()
  },

  mounted () {},

  methods: {
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    init1 () {
      getZJXQSList().then((response) => {
        var list = response.data
        console.log('list1:', list)
        this.dataList1 = list.sort(this.compare('sort'))
      })
    },
    init2 () {
      getXUYOUlist().then((response) => {
        var list = response.data
        console.log('list2:', list)
        this.dataList2 = list.sort(this.compare('sort'))
      })
    },
    init3 () {
      getPlayList().then((response) => {
        var list = response.data
        console.log('list3:', list)
        this.dataList3 = list.sort(this.compare('sort'))
      })
    },
    init4 () {
      getBeautyList().then((response) => {
        var list = response.data
        console.log('list4:', list)
        this.dataList4 = list.sort(this.compare('sort'))
      })
    },
    init5 () {
      getZHIYOUList().then((response) => {
        var list = response.data
        console.log('list5:', list)
        this.dataList5 = list.sort(this.compare('id'))
      })
    },
    // 通用
    first_method_public1 (value) {
      switch (value) {
        case 1:
          window.location.href = this.toUrl + '/cn?ids=' + '1'
          break
        case 2:
          window.location.href = this.toUrl + '/cn/scenery?ids=' + '2'
          break
        case 3:
          window.location.href = this.toUrl + '/cn/Culture?ids=' + '3'
          break
        case 4:
          window.location.href = this.toUrl + '/cn/history?ids=' + '4'
          break
        default:
      }
    },
    first_method_public2 (value) {
      switch (value) {
        case 1:
          window.location.href =
            this.toUrl + '/cn/InfomationAllOver?ids=' + '1'
          break
        case 2:
          window.location.href =
            this.toUrl + '/cn/InfomationAllOverForWork?ids=' + '2'
          break
        case 3:
          window.location.href =
            this.toUrl + '/cn/InfomationAllOverForNotion?ids=' + '3'
          break
        default:
      }
    },
    first_method_public3 (value) {
      switch (value) {
        case 1:
          window.location.href = this.toUrl + '/cn/PlayAllOver?ids=' + '1'
          break
        case 2:
          window.location.href =
            this.toUrl + '/cn/PlayAllOverForFood?ids=' + '2'
          break
        case 3:
          window.location.href =
            this.toUrl + '/cn/PlayAllOverForLive?ids=' + '3'
          break
        case 4:
          window.location.href =
            this.toUrl + '/cn/PlayAllOverForStudy?ids=' + '4'
          break
        case 5:
          window.location.href =
            this.toUrl + '/cn/PlayAllOverForBuy?ids=' + '5'
          break
        case 6:
          window.location.href =
            this.toUrl + '/cn/PlayAllOverForHappy?ids=' + '6'
          break
        default:
      }
    },
    first_method_public4 (value) {
      switch (value) {
        case 1:
          window.location.href = this.toUrl + '/cn/BeautyAllOver?ids=' + '1'
          break
        case 2:
          window.location.href =
            this.toUrl + '/cn/BeautyAllOverForMove?ids=' + '2'
          break
        case 3:
          window.location.href =
            this.toUrl + '/cn/BeautyAllOverForRadio?ids=' + '3'
          break
        case 4:
          window.location.href =
            this.toUrl + '/cn/BeautyAllOverFor720?ids=' + '4'
          break
        case 5:
          window.location.href =
            this.toUrl + '/cn/BeautyAllOverForBook?ids=' + '5'
          break
        default:
      }
    },
    fontright () {
      // alert('96969')
    },
    fontleftt () {
      //   alert('12121')
    },
    first_method_PlayAllOverForInfomation () {
      window.location.href = this.toUrl + '/cn/InfomationAllOver?ids=' + '1'
    },
    first_method_PlayAllOverForInfomationfor1 () {
      window.location.href = this.toUrl + '/cn/InfomationAllOver?ids=' + '1'
    },
    first_method_PlayAllOverForInfomationfor2 () {
      window.location.href =
        this.toUrl + '/cn/InfomationAllOverForWork?ids=' + '2'
    },
    first_method_PlayAllOverForInfomationfor3 () {
      window.location.href =
        this.toUrl + '/cn/InfomationAllOverForNotion?ids=' + '3'
    },

    first_method_BeautyAllOverForRadio () {
      window.location.href =
        this.toUrl + '/cn/BeautyAllOverForRadio?ids=' + '3'
    },
    first_method_BeautyAllOverForMove () {
      window.location.href = this.toUrl + '/cn/BeautyAllOverForMove?ids=' + '2'
    },
    first_method_BeautyAllOver () {
      window.location.href = this.toUrl + '/cn/BeautyAllOver?ids=' + '1'
    },
    first_method_history () {
      window.location.href = this.toUrl + '/cn/history?ids=' + '4'
    },
    first_method_scenery () {
      window.location.href = this.toUrl + '/cn/scenery?ids=' + '2'
    },
    first_method_PlayAllOverForHappy () {
      window.location.href = this.toUrl + '/cn/PlayAllOverForHappy?ids=' + '6'
    },
    first_method_PlayAllOverForBuy () {
      window.location.href = this.toUrl + '/cn/PlayAllOverForBuy?ids=' + '5'
    },
    first_method_PlayAllOverForStudy () {
      window.location.href = this.toUrl + '/cn/PlayAllOverForStudy?ids=' + '4'
    },
    first_method_PlayAllOverForLive () {
      window.location.href = this.toUrl + '/cn/PlayAllOverForLive?ids=' + '3'
    },
    first_method_PlayAllOver () {
      window.location.href = this.toUrl + '/cn/PlayAllOver?ids=' + '1'
    },
    first_method_PlayAllOverForFood () {
      window.location.href = this.toUrl + '/cn/PlayAllOverForFood?ids=' + '2'
    },
    first_method_Culture () {
      window.location.href = this.toUrl + '/cn/Culture?ids=' + '3'
    },
    // 类似的都需要优化，获取当前list为true的第一个菜单地址，跳入
    first_method () {
      // "buyOil.html?userId="+ res.userId;
      window.location.href = this.toUrl + '/cn?ids=' + '1'
      // 'https://' + testUrl +'baidu.com'
      // 'https://www.baidu.com'
      // 'https://' + testUrl +'baidu.com'
      // domain + port + '/jpn'
      // 'http://120.78.3.12:9102/#/'
      // uni.navigateTo({
      // 	url: 'pages/test',
      // });
    },
    first_method_to_jpn () {
      // window.location.href = this.toUrl + "/jpn";
      window.open(this.toUrl + '/jpn')
    },
    first_method_to_en () {
      window.open(this.toUrl + '/en')
      // window.location.href = this.toUrl + "/en";
    }
  }
}
</script>

<style >
/* menutopOnly */

.justcolor{
  color: #7f7f7f !important;;
}

li:hover {
  color: #36be73 !important;
}
a:hover {
  color: #d99c58 !important;
}

.hover4:hover a {
  color: #36be73 !important;
}
.hover4 {
  transition: All 0.4s ease-in-out;
  -webkit-transition: All 0.4s ease-in-out;
  -moz-transition: All 0.4s ease-in-out;
  -o-transition: All 0.4s ease-in-out;
}
.hover4:hover {
  transform: rotate(360deg);
  transform: translate(10px, -0);
  -webkit-transform: translate(10px, -0);
  -moz-transform: translate(10px, -0);
  -o-transform: translate(10px, -0);
  -ms-transform: translate(10px, -0);
  color: 36be73;
}
.font20 {
  font-size: 16px;
  color: #555555 !important;
  font-weight: 550;
  /* font-family: "Microsoft Yahei","微软雅黑","Hiragino Sans GB","冬青黑体","Arial","Helvetica","SimHei","黑体","STXihei","华文细黑",sans-serif; */
}
.font16 {
  font-size: 14px;
}
.menubot a:active,
.menubot a:hover {
  color: #39b485;
}

.menubot {
  width: 950px;
  margin: 0px auto;
  font-size: 15px;
  line-height: 36px;
}
.menulink a {
  margin-right: 60px;
}
.titletopsty {
  color: #555555 !important;
}
li {
  margin-bottom: 10px;
  color: #7f7f7f;
}
.folatL30 {
  float: left;
  width: 30%;
}
a {
  color: #7f7f7f ;
}
</style>



// WEBPACK FOOTER //
// src/components/menutop.vue